import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResponseData } from 'src/app/Model/Base/Response';
import { LegalRepresentativeModel } from 'src/app/Model/LegalRepresentative.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { DocumentTypeModel } from 'src/app/Model/DocumentType.model';
import { RequestService } from 'src/app/Services/request/request.service';
import Swal from 'sweetalert2';
import { CustomValidators } from 'src/app/Util/CustomValidators';
import { TranslateService } from '@ngx-translate/core';
import { CountryModel } from 'src/app/Model/Country.model';
import { VRequestStatusProcessModel } from 'src/app/Model/VRequestStatusProcess.Model';
import { crmGeoService } from 'src/app/Services/crm-geo-service/crm-geo-service.service';
import { environment } from 'src/environments/environment';
import { PiaFlowsValidationService } from 'src/app/Services/PiaFlowsValidation/pia-flows-validation.service';
import { Flows } from 'src/app/Model/Enums/Flow.enums';
import { CreateLegalRepresentativeRequest } from 'src/app/Model/createLegalRepresentativeRequest';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { Router } from '@angular/router';
import { StatusChangeByComponentView } from 'src/app/Model/StatusChangeByComponentView.model';
import { RequesStatusService } from 'src/app/Services/RequestStatus/RequesStatus.service';
import { MessagesModel } from 'src/app/Model/Messages.model';
import { Sections } from 'src/app/Model/Enums/Sections.enum';
import { TradeResponse } from 'src/app/Model/TradeModels/TradeResponse.model';

@Component({
  selector: 'app-legal-representative',
  templateUrl: './legal-representative.component.html',
  styleUrls: ['./legal-representative.component.css']
})
export class LegalRepresentativeComponent implements OnChanges {

  todayDate:Date = new Date();
  public isMobile: boolean = false;
  @Output() newRequestEvent = new EventEmitter<number>();
  @Output() updateCrmEvent = new EventEmitter<boolean>();
  @Input() lstDocumentTypes: DocumentTypeModel[];
  @Input() lstCountries: CountryModel[];
  @Input() request: RequestModel;
  @Input() lstStatuses: VRequestStatusProcessModel[];
  lstDocTypes: DocumentTypeModel[];
  newRequest: RequestModel;
  legalRepresentative: LegalRepresentativeModel;
  selectedCountry: CountryModel
  allowEdit: boolean;
  hideSaveButton: boolean = false;
  extCountryBool: boolean = false;
  typeDocumentNewIata: boolean = false;
  showChangeMotives: boolean = false;
  syncFlows = new Set([Flows.Flujo3_1,Flows.Flujo3_2,Flows.Flujo4_1,Flows.Flujo4_2,Flows.Flujo6_1,Flows.Flujo6_2])
  public Flows = Flows;
  @ViewChild('popUp', { static: false })
  popUp: ElementRef;
  form = new FormGroup({
    name: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.AmpersandValidator(),
      CustomValidators.NoDoubleSpaceAllowedValidator(),
      Validators.maxLength(100),]),
    lastname: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.AmpersandValidator(),
      CustomValidators.NoDoubleSpaceAllowedValidator(),
      Validators.maxLength(100),]),
    
    nationality: new FormControl('',
    [Validators.required
    ]),
    documentType: new FormControl('',
      [Validators.required
      ]),
    documentTypeName: new FormControl('',
      [
      ]),
    documentNumber: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlySiglaValidator(),
      CustomValidators.NumbersNoRepeatedValidator(),
      Validators.maxLength(30),]),
    documentNumberExt: new FormControl('',
      [
        Validators.maxLength(30),]),
    email: new FormControl('',
      [Validators.required,
      CustomValidators.emailValidator(),
      Validators.maxLength(500),]),
    birthDate: new FormControl('',[Validators.required]
    ),
  });

  formChangeMotive = new FormGroup({
    motive: new FormControl('',[Validators.required]),
    explanation: new FormControl(''),
  })
  @Output() nextEvent = new EventEmitter();
  nextStep() {
    this.nextEvent.emit();
  }
  @Output() prevEvent = new EventEmitter();
  prevStep() {
    this.prevEvent.emit();
  }
  get name() { return this.form.get('name'); }
  get lastname() { return this.form.get('lastname'); }
  get documentType() { return this.form.get('documentType'); }
  get documentTypeName() { return this.form.get('documentTypeName'); }
  get documentNumber() { return this.form.get('documentNumber'); }
  get documentNumberExt() { return this.form.get('documentNumberExt'); }
  get email() { return this.form.get('email'); }
  get nationality() { return this.form.get('nationality'); }
  get birthDate() { return this.form.get('birthDate'); }

  get motive() { return this.formChangeMotive.get('motive'); }
  get explanation() { return this.formChangeMotive.get('explanation'); }

  constructor(
    breakpointObserver: BreakpointObserver,
    private readonly requestService: RequestService,
    private readonly spinner: NgxSpinnerService,
    private readonly translate: TranslateService,
    private readonly crmGeoService: crmGeoService,
    private readonly piaFlowsValidationService: PiaFlowsValidationService,
    private readonly lsService : SessionStorageService,
    private readonly router: Router,
    private readonly RequestStatus: RequesStatusService
  ) {

    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });
  }
  ngOnChanges() {
    let countryColombia = environment.request.countryColombia;
    this.name.enable()
    this.lastname.enable()
    this.documentType.enable();
    this.documentNumber.enable();
    this.email.enable();
    this.birthDate.disable();
    if(this.request.IdFlow == Flows.CambioRepresentanteAdministrador){
      this.motive.enable();
      this.explanation.enable();
    }

    this.allowEdit = this.lstStatuses.some(x => x.IdComponent == Sections.RepLegal)
    if (this.legalRepresentative == null || (this.legalRepresentative.Id == null && this.request.LegalRepresentative != null && this.request.LegalRepresentative.length > 0)) {
      this.newRequest = Object.assign({}, this.request);
      if (this.newRequest != null && this.newRequest.LegalRepresentative != null && this.newRequest.LegalRepresentative.length > 0) {
        this.legalRepresentative = this.newRequest.LegalRepresentative[0];

      }
      else
        this.legalRepresentative = new LegalRepresentativeModel();
    }
    if (this.request != null && this.request.RequestStatus != null && !this.allowEdit) {
      if (this.request.IsUpdateCrm != true) {
        this.name.disable()
        this.lastname.disable()
        this.documentType.disable();
        this.documentTypeName.disable();
        this.birthDate.disable();
        this.documentNumber.disable();
        this.documentNumberExt.disable();
        this.email.disable();
        this.motive.disable();
        this.explanation.disable();
      }

      else if (this.request.IsUpdateCrm && this.request.RequestStatus == 5 && this.request.UpdateCrmDone == 7) {
        this.name.disable()
        this.lastname.disable()
        this.documentNumber.disable();
        this.documentNumberExt.disable();
        this.email.disable();
        this.documentType.disable();
        this.documentTypeName.disable();
        this.birthDate.disable();
      }
    }

    if (this.newRequest.IsNewIata) {
      this.name.disable();
      this.lastname.disable();
      this.documentNumber.disable();
      this.documentType.disable();
      this.documentNumberExt.disable()
      this.email.disable();
      this.documentTypeName.disable();
      this.typeDocumentNewIata = true;
    } else {
      this.typeDocumentNewIata = false;
      if ((this.request?.LegalRepresentative != null && this.request?.LegalRepresentative.length > 0) 
          && this.request?.LegalRepresentative[0].IdNationality == countryColombia) {
            this.extCountryBool = false
            if (this.request != null && this.request.RequestStatus != null && this.request.RequestStatus != 8  && !this.allowEdit) {
              this.documentNumber.disable()
            }
            else {
              this.documentNumber.enable()
            }

            this.documentNumberExt.disable()
      }
      else if (this.legalRepresentative != null && this.legalRepresentative.IdNationality == environment.request.countryUnitedStates ||
        this.legalRepresentative.IdNationality == environment.request.countryUnitedKingdom ||
        this.legalRepresentative.IdNationality== environment.request.countryIsrael ||
        this.legalRepresentative.IdNationality == environment.request.countryGermany)
        {
        this.extCountryBool = true
        this.documentNumber.disable()
        this.documentType.disable()
        if (this.request != null && this.request.RequestStatus != null && this.request.RequestStatus != 8 && !this.allowEdit) {
          this.documentNumberExt.disable()
          this.documentTypeName.disable()
        }
        else {
          this.documentNumberExt.enable()
          this.documentTypeName.enable()
        }
      }
    }

    if (this.request.LegalRepresentative != null && this.request.LegalRepresentative.length > 0) {
      this.legalRepresentative.Name = this.request.LegalRepresentative[0].Name
      this.legalRepresentative.LastName = this.request.LegalRepresentative[0].LastName

      this.legalRepresentative.DocumentType = this.request.LegalRepresentative[0] != null ? this.request.LegalRepresentative[0].DocumentType : ""

      if (this.request.LegalRepresentative[0] != undefined) {
        let countryOther = environment.request.countryOthers
        this.loadDocTypes(countryOther)
        if (this.request.LegalRepresentative[0].IdNationality == undefined && this.request.IsNewIata) {
          this.legalRepresentative.IdNationality = this.lstCountries.find(x => x.Name == 'Otro').Code
        }
      }
    }
    //Si el representante es de UK, USA, Alemania o Israel, se le habilita el campo de fecha de nacimiento
    if (this.legalRepresentative != null && this.legalRepresentative.IdNationality == environment.request.countryUnitedStates ||
      this.legalRepresentative.IdNationality == environment.request.countryUnitedKingdom ||
      this.legalRepresentative.IdNationality== environment.request.countryIsrael ||
      this.legalRepresentative.IdNationality == environment.request.countryGermany) {
      if(this.disableoption()){
        this.birthDate.disable()
      }
      else{
        this.birthDate.enable()
      }
    }
    //Habilitar los mótivos del cambio del representante legal
    if(this.request.IdFlow == Flows.CambioRepresentanteAdministrador){
      const matGroupValues = ["rolchange","companyChange","death"]
      if(this.legalRepresentative.changeMotive != undefined){
        if(matGroupValues.find(x => x == this.legalRepresentative.changeMotive) == undefined){
          this.motive.setValue("other")
          this.explanation.setValue(this.legalRepresentative.changeMotive)
        }
        else{
          this.motive.setValue(this.legalRepresentative.changeMotive)
        }
      }
      this.showChangeMotives = true
    }

    if(this.request != null && this.syncFlows.has(this.request.IdFlow)){
      this.name.disable();
      this.lastname.disable();
      this.documentNumber.disable();
      this.documentNumberExt.disable();
      this.email.disable();
      this.documentTypeName.disable()
      this.documentType.disable()
    }
  }

  disableoption(): boolean {
    if (this.request != null && this.request.RequestStatus != null && !this.allowEdit) {
      if (this.request.IsUpdateCrm != true) {
        return true
      }
      else if (this.request.IsUpdateCrm && this.request.UpdateCrmDone == 7 && this.request.RequestStatus == 5) {
        return true
      }
      else {
        return false
      }
    }
  }

  async onSubmit(): Promise<void> {
    this.hideSaveButton = true;
    this.spinner.show();
    this.legalRepresentative.IdRequest = this.request.Id
    let res: ResponseData;
    let validIataAndLegalRep = false
    if(this.request.IdFlow == Flows.Primeringreso || this.request.IdFlow == Flows.CambioRepresentanteAdministrador){
      let createLegalRepRequest = new CreateLegalRepresentativeRequest()
      createLegalRepRequest.agentEmail = this.legalRepresentative.Email
      createLegalRepRequest.iataCode = this.request.Iata
      createLegalRepRequest.language = this.lsService.getLSItem('language')

      let response = await this.piaFlowsValidationService.CanCreateLegalRepresentative(createLegalRepRequest)

      if(!response.succeeded){
        await this.handleTradeResponse(response)
      }
      else{
        if(this.request.IdFlow == Flows.CambioRepresentanteAdministrador){
          this.legalRepresentative.changeMotive = this.motive.value == "other" ? this.explanation.value : this.motive.value
        }
        validIataAndLegalRep = true
      }    
    }
    
    if((validIataAndLegalRep && (this.request.IdFlow == Flows.Primeringreso || this.request.IdFlow == Flows.CambioRepresentanteAdministrador)) || 
      (!validIataAndLegalRep && this.request.IdFlow != Flows.Primeringreso && this.request.IdFlow != Flows.CambioRepresentanteAdministrador)){
      await this.requestService.postLegalRepresentative(this.legalRepresentative).then(resp => {
        res = resp;
      })
      this.spinner.hide();
      if (res.head.status.toLowerCase() == 'true') {
        let json: LegalRepresentativeModel = JSON.parse(res.body.response);
        this.legalRepresentative = json;
        this.newRequestEvent.emit(this.request.Id);
        if (this.request.IsUpdateCrm) {
          this.updateCrmEvent.emit(false);
        }
        await Swal.fire({
          html: this.popUp.nativeElement,
          width: 300,
          showCloseButton: true,
          showConfirmButton: false,
        })
        this.hideSaveButton = false;
        this.nextStep()
      }
      else {
        await Swal.fire({
          title: 'Error!',
          text: this.translate.instant('Request.Messages.ErrorSaving'),
          icon: 'error'
        }
        )
      }
      this.hideSaveButton = false;
    }
  }

  private async handleTradeResponse(response: TradeResponse) {
    let tradeResponseMessage = response.message;
        if(this.lsService.getLSItem("language") == 'es')
          tradeResponseMessage = response.message.replace('{UrlconsultasFrecuentes}',environment.consultasFrecuentesEs)
        else if(this.lsService.getLSItem("language") == 'en')
          tradeResponseMessage = response.message.replace('{UrlconsultasFrecuentes}',environment.consultasFrecuentesEn)
        else if(this.lsService.getLSItem("language") == 'pt')
          tradeResponseMessage = response.message.replace('{UrlconsultasFrecuentes}',environment.consultasFrecuentesPt)
        await this.spinner.hide();
        await Swal.fire({
          title: this.translate.instant('Request.Messages.UnauthorizedAccess'),
          html: tradeResponseMessage,
          icon: 'warning',
          showConfirmButton: true
        }).then( async () => {
          this.spinner.show();
          let messageRequest = new MessagesModel();
          messageRequest.Message = tradeResponseMessage
          let statusChange = new StatusChangeByComponentView()
          statusChange.Approve = false;
          statusChange.IdComponent = Sections.FormularioVinculacion;
          statusChange.IdProfile = null;
          statusChange.IdRequest = this.request.Id;
          statusChange.Messages = [messageRequest]
          await this.RequestStatus.SetStatusByComponent(statusChange).then(async resp => {
            await this.spinner.hide();
            this.router.navigate(['Register'])
          })
        });
  }

  public fillNames(fullName) {
    this.name.setValue(fullName.split(" ")[0])
    this.lastname.setValue(fullName.split(" ")[2])
  }

  async selectDocType(event,evt) {
    if(event.isUserInput){
      this.legalRepresentative.BirthDate = undefined;
      let countryOther = environment.request.countryOthers
      let countryColombia = environment.request.countryColombia
      if(this.lstDocTypes == undefined || this.lstDocTypes.length == 0)
        this.loadDocTypes(countryOther)
      this.legalRepresentative.IdNationality = evt.Code
      this.legalRepresentative.NationalityName = evt.Name
      if (evt.Code == countryColombia) {
        this.extCountryBool = false
        this.documentNumber.enable()
        this.documentNumberExt.disable()
        this.birthDate.disable()
      }
      else if (this.legalRepresentative.IdNationality == environment.request.countryUnitedStates ||
        this.legalRepresentative.IdNationality == environment.request.countryUnitedKingdom ||
        this.legalRepresentative.IdNationality== environment.request.countryIsrael ||
        this.legalRepresentative.IdNationality == environment.request.countryGermany) {
        this.extCountryBool = true;
        this.typeDocumentNewIata = true; 
        
        if (!this.newRequest.IsNewIata) {
          
          this.documentNumberExt.enable()
          this.documentTypeName.enable()
        }
        else{
          this.documentNumberExt.disable()
          this.documentTypeName.disable()
        }

        this.documentType.disable()
        this.documentNumber.disable()
        this.birthDate.enable()

        
      } else {
        this.extCountryBool = false;
        this.typeDocumentNewIata = false;

        if (!this.newRequest.IsNewIata) {
          this.documentNumber.enable()
          this.documentType.enable()
        }
        else{
          this.documentNumber.disable()
          this.documentType.disable()
        }

        this.documentTypeName.disable()
        this.documentNumberExt.disable()
        this.birthDate.disable()
      }
    }
  }

  async DocTypeSelected(event,evt) {
    if(event.isUserInput)
      this.legalRepresentative.DocumentTypeName = evt.Description
  }

  

  async loadDocTypes(country) {
    await this.crmGeoService.getDocumentTypesCrm(country).then(res => {
      this.lstDocTypes = res;
    });
  }

  showMotiveExplanation(): boolean{
    if(this.motive.value == "other"){
      this.explanation.setValidators([CustomValidators.emptyTextValidator(),
        CustomValidators.AmpersandValidator(),
        Validators.maxLength(100),
        Validators.required
      ])
      return true
    }
    else{
      this.explanation.clearValidators()
      this.explanation.setValue("")
      return false
    }
  }

}

